module.exports = __webpack_public_path__ + "static/media/S-task03_nodeLink.cabb8101.png";